import React from "react"
import "swiper/css"
import "swiper/css/effect-fade"
import { initSal } from "./src/utils/sal"
import { ViewModeProvider } from "./src/context/viewMode"
import { MenuProvider } from "./src/context/menuContext"

export const wrapRootElement = ({ element }) => (
    <ViewModeProvider>
        <MenuProvider>{element}</MenuProvider>
    </ViewModeProvider>
)

export const onInitialClientRender = () => {
    initSal()
}

export const onRouteUpdate = () => {
    initSal()
}